module.exports = __webpack_public_path__ + "static/media/dex-force.a3f960f7.png";